<template>
  <header>
    <article class="logo">
      <a>
        <img class="logo-img"
          v-if="webOrderShopImageUrl !== null"
          :src="webOrderShopImageUrl"
        />
      </a>
    </article>
  </header>
</template>
<script>
import { baseUrl } from "../server";
import { http } from "../axios";
export default {
  props: {
    shopCode: {
      type: String,
      default: () => {
        return {};
      }
    }
  },
  // watch: {
  //   shopCode() {
  //     const t = this;



  //     http
  //       .get(`${baseUrl}/api/GetShopProfile?shopCode=${t.shopCode}`)
  //       .then(response => {
  //         if (response.data.responseCode === 0) {
  //           t.webOrderShopImageUrl = response.data.profile.menuLogoUrl;
  //         } else console.log(response.data.responseMessage);
  //       })
  //       .catch(error => {
  //         console.log(error);
  //       });

  //   }
  // },
  data() {
    return {
      webOrderShopImageUrl: null
    };
  }
};
</script>
<style scoped>
.logo {
  padding: 0.1em;
  width: 100%;
  height: 30%;
}
.logo-img {
  width: auto;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/Components/LogoHeader.vue